/**
 * Component: Product thumbmail scroll events
 * -----------------------------------------------------------------------------
 * - A set of event listeners to handle body scroll lock commands emitted by
 * product-thumbnails-slider.
 *
 * @namespace productForm
 */

import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock'

/**
 * DOM selectors.
 */
const selectors = {
  slider: '.js-featuredSlider',
  container: '[data-component="ProductThumbnailsSlider"]',
}

/**
 * Attribute and data selectors.
 */
const dataSelectors = {
  scrollLockClass: 'scroll-locked',
}

/**
 * State settings
 */
const state = {
  scrolling: false,
  slideEdge: true,
}

export default () => {

  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    container: document.querySelector(selectors.container),
    slider: document.querySelector(selectors.slider),
  }

  /**
   * Initiate
   */
  function init() {
    setEventListeners()
  }

  /**
   * Set all event listeners
   * - listen for events from product thumbnails slider to update body scroll
   * lock
   */
  function setEventListeners() {
    window.basis.EventBus.listen('swiper-slide-edge', (data) => {
      state.slideEdge = data
    })

    window.basis.EventBus.listen('swiper-slide-scrolling', (data) => {
      state.scrolling = data
    })

    window.basis.EventBus.listen('swiper-enable-body-scroll', () => {
      handleEnableScroll()
    })

    window.basis.EventBus.listen('swiper-disable-body-scroll', () => {
      handleDisableScroll()
    })

    nodeSelectors.slider.addEventListener('mouseenter', () => {
      if (window.matchMedia('(max-width: 767px)').matches) {
        return
      }

      if (!state.slideEdge) {
        handleDisableScroll()
      }
    })

    /**
     * Enable body scroll when mouse leaves slider container.
     * - cancels enable scroll if slider is not finished. This is set to 100ms
     * and is to avoid premature mouseout event bug.
     */
    nodeSelectors.container.addEventListener('mouseout', () => {
      if (state.scrolling || window.matchMedia('(max-width: 767px)').matches) {
        return
      }

      handleEnableScroll()
    })

    nodeSelectors.slider.addEventListener('wheel', (event) => {
      if (window.matchMedia('(max-width: 767px)').matches) {
        return
      }

      if (window.scrollY > 10 && event.wheelDeltaY > 0) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
      }
    })
  }

  /**
   * Enables body scroll.
   */
  function handleEnableScroll() {
    clearAllBodyScrollLocks()
    document.body.classList.remove(dataSelectors.scrollLockClass)
  }

  /**
   * Disables body scroll.
   */
  function handleDisableScroll() {
    disableBodyScroll(nodeSelectors.slider, {
      reserveScrollBarGap: true,
    })

    document.body.classList.add(dataSelectors.scrollLockClass)
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  })
}
